import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { RestrictionLevelClearTopupThreshold } from "@warrenio/api-spec/spec.oats.gen";

type Response = RestrictionLevelClearTopupThreshold;

const queryKey: QueryKey = ["restriction_level_clear_topup_threshold"];

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<Response> =>
            getResponseData(await client.GET("/config/payment/restriction_level_clear_topup_threshold", { signal })),
    });
}

export const queryAtom = atomFromStandardQueryOptions(getQuery);
